import { render, staticRenderFns } from "./TextContent.vue?vue&type=template&id=3a5d0b62&"
import script from "./TextContent.vue?vue&type=script&lang=ts&"
export * from "./TextContent.vue?vue&type=script&lang=ts&"
import style0 from "./TextContent.vue?vue&type=style&index=0&id=3a5d0b62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports